let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i2ykV")).then(() => parcelRequire('i6y0w'));